import { createAction, props } from '@ngrx/store';
import {Role} from "../../../shared/models/role.model";
import {User} from "../../../shared/models/user.model";

export const loadUsers = createAction('[Users Data Access] Load Users');
export const loadUsersSuccess = createAction(
  '[User Data Access] Users Load Success',
  props<{ users: User[] }>()
);

export const loadUsersFailure = createAction(
  '[User Data Access] Users Load Failure',
  props<{ error: string }>()
);

export const addUser = createAction(
  '[User Component] Add Users',
  props<{ user: User }>()
);

export const addUserSuccess = createAction(
  '[User Data Access] Users Add Success',
  props<{ user: User, successMessage: string }>()
);

export const addUserFailure = createAction(
  '[User Data Access] Users Add Failure',
  props<{ error: string }>()
);

export const modifyUser = createAction(
  '[User Component] Modify Users',
  props<{ user: User }>()
);

export const modifyUserSuccess = createAction(
  '[User Data Access] Users Modify Success',
  props<{ user: User, successMessage: string }>()
);

export const modifyUserFailure = createAction(
  '[User Data Access] Users Modify Failure',
  props<{ error: string }>()
);

export const removeUser = createAction(
  '[User Component] Remove User',
  props<{ userId: string }>()
);

export const removeUserSuccess = createAction(
  '[User Data Access] User Remove Success',
  props<{ userId: string, successMessage: string }>()
);

export const removeUserFailure = createAction(
  '[User Data Access] User Remove Failure',
  props<{ error: string }>()
);

export const loadRoleDropDownData = createAction('[UserList Component] Load RoleDropDownData');
export const loadRoleDropDownDataSuccess = createAction(
  '[Role Data Access] RoleDropDownData Load Success',
  props<{ roles: Role[] }>()
);

export const loadRoleDropDownDataFailure = createAction(
  '[Role Data Access] RoleDropDownData Load Failure',
  props<{ error: string }>()
);

export const updateUsersRole = createAction('[UserList Component] Update UsersRole',
  props<{ userId: string, roleId: string }>()
);

export const updateUsersRoleSuccess = createAction(
  '[User Data Access] Update UsersRole Success',
  props<{ users: any[], successMessage: string }>()
);

export const updateUsersRoleFailure = createAction(
  '[User Data Access] Update UsersRole Failure',
  props<{ error: string }>()
);

export const disableUser = createAction('[UserList Component] Disable User',
  props<{ userId: string }>()
);

export const disableUserSuccess = createAction(
  '[User Data Access] Disable User Success',
  props<{ userId: string, successMessage: string }>()
);

export const disableUserFailure = createAction(
  '[User Data Access] Disable User Failure',
  props<{ error: string }>()
);


